"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_THUMBNAIL_SIZE = void 0;
// same size as what gets returned by https://img.youtube.com/vi/${sourceId}/hqdefault.jpg
exports.DEFAULT_THUMBNAIL_SIZE = '480x360';
//# sourceMappingURL=constants.js.map